import AdvanceSearchContainer from "../../container/admin/advance-search";

const AdvanceSearch = () => {
    return <AdvanceSearchContainer />;
};

export default AdvanceSearch;